import Button from '../Button';
import { secondarySchoolLessonNumberLookup } from '../../GlobalFunctions';
import { getPublicMediaRoot } from '../../serviceAgent';
import styles from './ToDoCard.module.scss';
import { InlineIcon } from '@iconify/react';
import eyeOutline from '@iconify-icons/ion/eye-outline';
import bxEditAlt from '@iconify-icons/bx/bx-edit-alt';
import checkmarkCircleOutline from '@iconify/icons-eva/checkmark-circle-outline';
import { Assignment } from '@peekapak/types/LessonPlanTypes';

interface ToDoProps {
  handleClick: (arg0: Assignment) => void;
  toDoObject: Assignment;
  grade: number;
}

const ToDoCard = ({ grade, toDoObject, handleClick }: ToDoProps): JSX.Element => {
  const { lesson, status, todoRepresentativeImage, todoTitle, unitDisplayName } = toDoObject;

  const isHighSchool = grade > 8;

  const imgPath = `${getPublicMediaRoot()}images/secondary/${todoRepresentativeImage}`;

  return (
    <div className={styles.container}>
      <img src={imgPath} alt='activity type illustration' />
      <div className={styles.cardContent}>
        <div className={styles.textColumn}>
          <h2>{todoTitle}</h2>
          {/*<div>Est. 999 mins.</div>*/}
          <div className={styles.lessonInfoRow}>
            {unitDisplayName} &#8226;&nbsp;
            <div>
              Lesson {secondarySchoolLessonNumberLookup(lesson, isHighSchool)}: {toDoObject.lessonTitle ?? lesson}
            </div>
          </div>
        </div>
        <div className={styles.buttonColumn}>
          {status === 'submitted' && (
            <>
              <div className={styles.textRow}>
                <InlineIcon
                  icon={checkmarkCircleOutline}
                  width={18}
                  style={{
                    marginRight: '0.5em',
                    transform: 'translateY(-2px)',
                    color: '#16c98d',
                  }}
                />
                <p>COMPLETE</p>
              </div>
              <Button thinText whiteBorder onClick={() => handleClick(toDoObject)}>
                <InlineIcon
                  icon={eyeOutline}
                  width={18}
                  style={{
                    marginRight: '0.5em',
                    transform: 'translateY(2px)',
                  }}
                />
                View Submission
              </Button>
            </>
          )}
          {(status === 'inProgress' || status === 'retracted') && (
            <>
              <div className={styles.textRow}>
                <InlineIcon
                  icon={bxEditAlt}
                  width={18}
                  style={{
                    marginRight: '0.5em',
                    transform: 'translateY(-2px)',
                    color: '#00afd8',
                  }}
                />
                <p>IN PROGRESS</p>
              </div>
              <Button darkBlue thinText onClick={() => handleClick(toDoObject)}>
                Continue
              </Button>
            </>
          )}
          {status === 'assigned' && (
            <Button darkBlue thinText onClick={() => handleClick(toDoObject)}>
              Get Started
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ToDoCard;
